export const ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  CAMPAIGNS: "/campaigns",
  LANDINGS: "/landings",
  LINKS: "/links",
  UI_DEMO: "/ui-demo",
  LOGIN: "/login",
  TEAM: "/team",
  DOMAINS: "/domains",
  INTEGRATIONS: "/integrations",
  BILLING: "/billing",
};

// Single source of truth for the backend origin: the API and the public
// tracking-link redirects (/t/{shortCode}) are both served by this host.
const API_ORIGIN = import.meta.env.VITE_API_ORIGIN || "http://localhost:8080";

console.log(
  "DEBUG ENV:",
  import.meta.env.MODE,
  import.meta.env.VITE_API_ORIGIN,
  API_ORIGIN,
);

export const APP_CONFIG = {
  APP_NAME: "Kemblo",
  API_BASE_URL: `${API_ORIGIN}/api`,
  TRACKING_ORIGIN: API_ORIGIN,
};
